import { useContext } from "@/store/context";
import axios from "axios";
import { markRaw } from "vue";
import VueI18n from "vue-i18n";
import Formatter from "./formatter";
const translationsPath = "/i18n-text";
const defaultLocale = "en";
const formatter = new Formatter();
const messages = {};
export const i18n = new VueI18n({
    locale: defaultLocale,
    formatter,
    messages
});
let translationsPromise = null;
export const i18nSetup = async () => {
    const context = useContext();
    await context.load();
    const localeParam = context.currentLocale ? `&hl=${encodeURIComponent(context.currentLocale)}` : "";
    const translationUrl = `${translationsPath}?ts=${context.resourceTimestamp}${localeParam}`;
    if (!translationsPromise) {
        translationsPromise = axios.get(translationUrl, {
            withCredentials: true,
            headers: { "X-Requested-With": "XMLHttpRequest" }
        });
    }
    const messages = await translationsPromise;
    const locale = context.currentLocale || defaultLocale;
    i18n.setLocaleMessage(locale, messages.data);
    i18n.locale = locale;
    i18n.formatter = new Formatter({ locale: locale.replace("_", "-") });
    return {
        install: (app) => {
            app.config.globalProperties.$t = (key, values) => {
                // Our translations are always simple strings
                return i18n.t(key, values);
            };
            app.provide("i18n", i18n);
        }
    };
};
export const i18nPinia = (context) => {
    context.store.i18n = markRaw(i18n);
};
